import { FormatPreview } from "../models/format-preview";
import { axiosInstance } from "../../utils/axios";

export function formatPreview(request: FormatPreview): Promise<string> {
  return axiosInstance.post(`/format/preview`, request, { params: { notShowLoading: true } }).then((resp) => resp.data);
}
